export const Options = {
  data: [
    {
      label: '所有入账',
      value: '1'
    },
    {
      label: '所有出账',
      value: '2'
    },
    {
      label: '提现',
      value: '3'
    },
    {
      label: '转发',
      value: '4'
    },
    {
      label: '推页红包',
      value: '5'
    },
    {
      label: '余额退回',
      value: '6'
    },
    {
      label: '充值（后台）',
      value: '7'
    },
    {
      label: '分润金额',
      value: '8'
    }
  ]
}

export const CouponOptions = {
  data: [
    {
      label: '卡卷类型',
      value: '0'
    },
    {
      label: '代金券',
      value: '1'
    },
    {
      label: '免单卡',
      value: '2'
    }
  ]
}
